<template>
  <div>
    <LoadingPage v-if="isFetchingFields">
      <template v-slot:title>
        {{ $t('ui.envelopes.create.steps.fields.fetchingPrefillableFields') }}
      </template>
    </LoadingPage>
    <PrefillFieldsScreen
      v-else
      :envelopePartyFields="envelopePartyFields"
    />
  </div>
</template>

<script setup>
// @ts-check
import { useRoute } from 'vue-router/composables';

import {
  useEnvelopeFields,
} from '@/composables/envelopes';

import { LoadingPage } from '@/components/library/loaders/loadingPage/LoadingPage';
import PrefillFieldsScreen from '@/components/screens/envelopes/PrefillFieldsScreen/PrefillFieldsScreen.vue';

const route = useRoute();

const {
  envelopePartyFields,
  isFetchingFields,
} = useEnvelopeFields(route.params.fingerprint);
</script>
